import { getDateTime } from "../../services/CheckMeProBlePackages";
import { ECGInnerItem    } from "./ECGInnerItem";
export interface ECGItem{

    date: Date
    voiceFlag: number
    measuringMode: number
    imgResult: number
    innerItem : ECGInnerItem
    measuringModeDescr:string
    imgResultDescr:string

}


export function parseEcgItem(data: number[]) :ECGItem[] {
    const returnString = "";
     const ECGs : ECGItem [] = new Array();
     
    const block = 0;

     for (let i = 0; i <data.length; i++) {
      const item = {} as ECGItem;
      item.date = getDateTime(data, i);
      item.measuringMode = data[i + 7];
      item.imgResult = data[i + 8];
      //yyyymmddhhmmss

      i = i + 9;

      ECGs.push(item);

      switch (item.imgResult) {
        case 0:
          item.imgResultDescr = "happy";
          break;
        case 1:
          item.imgResultDescr = "sad";
          break;
      }
      switch (item.measuringMode) {
        case 1:
          item.measuringModeDescr = "hand-hand";
          break;
        case 2:
          item.measuringModeDescr = "hand-chest";
          break;
        case 3:
          item.measuringModeDescr = "1-lead";
          break;
        case 4:
          item.measuringModeDescr = "2-lead";
          break;
      }
    
    }
    return ECGs;

  }